import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Typography } from '@mui/material'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { withStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete'
import CustomizedSnackbars from '../../components/material-snackbars'
import { AbilityContext } from '../../config/ability-context'
import * as componentActions from '../../redux/actions/chats'
import { associateAllWithoutChannelChats, associateWithoutChannelChat, getChatsWithoutChannel as getChatsWithoutChannelService, getChatIndicators, getChatMessages, getTeamMismatchChats, GetChatList as GetChatListService, newConversation, getEnabledUserById, getEnabledUsers, getUserStatusList, getModalOptions, repairAllTeamMismatchChats, repairTeamMismatchChat } from '../../services/2talk/omnichannel'
import { GetAllActiveAndByMessageProvider } from '../../services/2talk/channel'
import { saveChannelAssociation } from '../../services/2talk/channelphoneregistrationrequests'
import Api2Talk from "../../services/api2talk"
import { Overlay } from '../../styles/global'
import { Styles } from '../../styles/material-styles'
import { PapiroConsole } from '../../utils/papiroConsole'
import AgentList from './components/agent-list/agent-list'
import ChatIndicators from './components/chat-indicators/chat-indicators'
import ItemCard from './components/item-card/item-card'
//import { Tabs, Tab } from '@mui/material';

import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes'
import ThreePIcon from '@mui/icons-material/ThreeP'
import LinkOffIcon from '@mui/icons-material/LinkOff'
import SyncAltIcon from '@mui/icons-material/SyncAlt'

import Badge from '@mui/material/Badge'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import AddIcon from '@mui/icons-material/Add';
import CustomModal from './components/custom-modal/custom-modal'
import ConversationMessagesModal from './components/conversation-messages-modal/conversation-messages-modal'
import TagSearchFilter from './components/item-card/components/tag-search-filter/index'
import TeamMismatchConversations from './components/team-mismatch-conversations/team-mismatch-conversations'
import WithoutChannelConversations from './components/without-channel-conversations/without-channel-conversations'
import { filterTeamMismatchGroups, filterWithoutChannelGroups, hasAdministrationQueueAccess, shouldShowAdministrationQueueBadge } from './utils/conversation-search'

import SimpleSelectWithRoundedColor from '../2talk-chat/components/chat/simple-with-rounded-color';
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

//import './tab.css'

const StyledPaper = withStyles({
  root: {
    '&::-webkit-scrollbar': {
      width: '9px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(63, 81, 180, 0.6)', /* Cor do thumb (cabeça da barra de rolagem) */
      borderRadius: '6px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1', /* Cor de fundo da barra de rolagem */
    },
  },
  expanded: {},
})(Paper);

/*const MyPaper = styled(Paper)({
  backgroundColor: (theme) => theme.palette.background.paper,
});

const MyTabs = styled(Tabs)({
  backgroundColor: (theme) => theme.palette.primary.main,
  color: (theme) => theme.palette.primary.contrastText,
});*/

class ToTalkChatAttendance extends Component {

  constructor(props) {
    super(props)
    const { userSession } = this.props;

    const intl = this.props.intl;

    this.initialState = {
      filterId: { id: 0, name: '' },
      chatFilterId: { id: 0, name: '' }
    };
    this.state = {
      item: this.initialState,
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      userSession: userSession,
      chats: [],
      count: 0,
      page: 1,
      pageStart: 0,
      filterOptions: [
        { id: 1, name: 'Conversas' }
      ],
      chatFilter: [],
      pageEnd: 0,
      statusOptions: [],
      enableUsers: [],
      userStatusId: 6,
      chatsInAttendance: [],
      myChatsInAttendance: [],
      otherChatsInAttendance: [],
      countMyChatsInAttendance: 0,
      countOtherChatsInAttendance: 0,


      chatsWaitingAttendance: [],
      countNewChats: 0,
      countInAttendanceChats: 0,
      countCanceledChats: 0,
      countFinishChats: 0,
      countChatsResolvedInTheFirstService: 0,
      countChatsNotResolvedInTheFirstService: 0,
      tabSelected: 0,
      userId: this.props.userSession && this.props.userSession.user && this.props.userSession.user.id ? this.props.userSession.user.id : 0,
      loadingAgents: false,
      loadingIndicators: false,
      loadingNewConversation: false,
      modalOpen: false,
      messageProvidersList: [
      ],
      registrationNumberRequestList: [
      ],
      templateMessageList : [], 

      // Novos estados para o filtro
      isFilterActive: false,
      filteredChatsWaitingAttendance: [],
      filteredMyChatsInAttendance: [],
      filteredOtherChatsInAttendance: [],
      conversationSearchTerm: '',
      withoutChannelGroups: [],
      canAssociateWithoutChannel: false,
      selectedWithoutChannelChannels: {},
      loadingWithoutChannel: false,
      associatingWithoutChannel: false,
      withoutChannelConfirmationOpen: false,
      withoutChannelConfirmationGroup: null,
      withoutChannelConfirmationChatId: null,
      channelAssociationOpen: false,
      channelAssociationGroup: null,
      channelAssociationOptions: [],
      channelAssociationSelectedId: '',
      loadingChannelAssociationOptions: false,
      savingChannelAssociation: false,
      channelAssociationDefaultConfirmationOpen: false,
      teamMismatchGroups: [],
      canRepairTeamMismatch: false,
      loadingTeamMismatch: false,
      repairingTeamMismatch: false,
      teamMismatchConfirmationOpen: false,
      teamMismatchConfirmationGroup: null,
      teamMismatchConfirmationChatId: null,
      conversationMessagesModalOpen: false,
      conversationMessagesChat: null,
      conversationMessages: [],
      loadingConversationMessages: false,
      conversationMessagesError: '',


    };

    PapiroConsole.log(this.props)
    PapiroConsole.log("this.props")
    //this.props.refreshDashboard(false);
    this.closeNotification = this.closeNotification.bind(this);
    this.updateChat = this.updateChat.bind(this);
    this.redirectChat = this.redirectChat.bind(this);

    this.changeStatus = this.changeStatus.bind(this);
    this.changeValues = this.changeValues.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.setLoading = this.setLoading.bind(this);
    this.setTemplateMessageList = this.setTemplateMessageList.bind(this);
    this.setTemplateMessageListComplete = this.setTemplateMessageListComplete.bind(this);
    this.setMessage = this.setMessage.bind(this);
      this.handleFilteredChatsChange = this.handleFilteredChatsChange.bind(this);

  }



  componentWillReceiveProps(nextProps) {
    //alert(JSON.stringify(nextProps.chats.refreshdashboard));
    //console.error(nextProps);
    //console.error(JSON.stringify(nextProps));
    //if (nextProps && nextProps.location && nextProps.location.state === "reload") {
    if (nextProps && nextProps.headerMenu && nextProps.headerMenu.refresh === true) {
      nextProps.headerMenu.refresh = false;
      this.componentDidMount();
    }
    else if (nextProps && nextProps.chats && nextProps.chats.refreshdashboard === true) {

      var refreshdashboard = true;
      nextProps.chats.refreshdashboard = false;
      this.componentDidMount(refreshdashboard);
    }
  }

  onChangePaginate = async (e, page) => {
    this.setState({
      loading: true,
    });



    this.setState({ page: page, countLoading: 0 });


    await this.getChats(page);
  }

  handleChange = (event, newValue) => {
    this.setState({ tabSelected: newValue });
  }

  // Método handleFilteredChatsChange CORRIGIDO no ToTalkChatAttendance

  handleFilteredChatsChange(filteredChats, isFilterActive) {
    if (!isFilterActive) {
      // Se não há filtros, limpa os estados filtrados
      this.setState({
        isFilterActive: false,
        filteredChatsWaitingAttendance: [],
        filteredMyChatsInAttendance: [],
        filteredOtherChatsInAttendance: [],
      });
      return;
    }
    
    // CORREÇÃO: Verifica se os arrays existem antes de filtrar
    const chatsWaitingAttendance = this.state.chatsWaitingAttendance || [];
    const myChatsInAttendance = this.state.myChatsInAttendance || [];
    const otherChatsInAttendance = this.state.otherChatsInAttendance || [];
    
    // Separa os chats filtrados por categoria
    const filteredWaiting = filteredChats.filter(chat => 
      chatsWaitingAttendance.some(original => original.id === chat.id)
    );
    
    const filteredMy = filteredChats.filter(chat => 
      myChatsInAttendance.some(original => original.id === chat.id)
    );
    
    const filteredOther = filteredChats.filter(chat => 
      otherChatsInAttendance.some(original => original.id === chat.id)
    );
    
    this.setState({
      isFilterActive: true,
      filteredChatsWaitingAttendance: filteredWaiting,
      filteredMyChatsInAttendance: filteredMy,
      filteredOtherChatsInAttendance: filteredOther,
    });
  }

  handleConversationSearchTermChange = conversationSearchTerm => {
    this.setState({ conversationSearchTerm })
  }

  setPagination(count, page, pageCount) {
    let result = {};
    let totalPage = Math.ceil(count / pageCount);
    //this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        if (count < pageCount) {
          //this.setState({ pageStart: 1, pageEnd: count });
          result.pageStart = 1;
          result.pageEnd = count;
        } else {
          //this.setState({ pageStart: 1, pageEnd: 10 });
          result.pageStart = 1;
          result.pageEnd = pageCount;
        }
      } else {
        let pageStart = ((page - 1) * pageCount) + 1;

        result.pageStart = pageStart;


        if (count >= page * pageCount) {
          // this.setState({ pageStart: pageStart, pageEnd: page * pageCount });
          result.pageEnd = page * pageCount;
        } else {
          //this.setState({ pageStart: pageStart, pageEnd: count });
          result.pageEnd = page * pageCount;
        }
      }
      result.totalPages = totalPage;
      result.page = page;
      result.count = count;
      result.pageCount = pageCount;


    } else {
      //this.setState({ pageStart: 0, pageEnd: 0, totalPages: 0, page: 1, count: 0 });
      result.totalPages = 0;
      result.page = 1;
      result.count = 0;
      result.pageStart = 0;
      result.pageEnd = 0;
      result.pageCount = pageCount;
    }
    return result;

  }
  closeNotification() {
    this.setState({ openNotification: false });
  }

  async callingFilters(id, filterId, chatFilterId) {
    await this.getChats(id, filterId, chatFilterId);
    await this.getChatIndicators(id, filterId, chatFilterId)
  }

  async getChats(id, filterId, chatFilterId, refreshdashboard) {
    // PapiroConsole.log("filterId")
    // PapiroConsole.log("chatFilterId")
    // PapiroConsole.log(filterId)
    // PapiroConsole.log(chatFilterId)
    if (refreshdashboard) {

      this.setState({ loadingNewConversation: true })

    }
    else {
      this.setState({ loading: true })
    }

    if (filterId && chatFilterId) {
      filterId = filterId.id
      chatFilterId = chatFilterId.id
    }
    let result = await GetChatListService(null, filterId, chatFilterId)
    if (result && result.success) {
      PapiroConsole.log("result endpoint")
      PapiroConsole.log(result)
      const responseData = result.data || {};
      let chatList = Array.isArray(responseData.totalchats) ? responseData.totalchats : [];
      let chatsInAttendance = Array.isArray(responseData.chatsinattendance) ? responseData.chatsinattendance : []

      let myChatsInAttendance = Array.isArray(responseData.mychatsinattendance) ? responseData.mychatsinattendance : [];
      let otherChatsInAttendance = Array.isArray(responseData.otherchatsinattendance) ? responseData.otherchatsinattendance : [];
      let countOtherChatsInAttendance = responseData.countotherchatsinattendance ? responseData.countotherchatsinattendance : 0
      let countMyChatsInAttendance = responseData.countmychatsinattendance ? responseData.countmychatsinattendance : 0
      let chatsWaitingAttendance = Array.isArray(responseData.chatswaitingattendance) ? responseData.chatswaitingattendance : []

      //this.props.addCurrentOmnichannelChatList(chatList);
      //this.props.addTotalChatCount(chatList.length);
      this.setState({ loading: false, loadingNewConversation: false, chats: chatList, countOtherChatsInAttendance: countOtherChatsInAttendance, countMyChatsInAttendance: countMyChatsInAttendance, chatsInAttendance: chatsInAttendance, myChatsInAttendance: myChatsInAttendance, otherChatsInAttendance: otherChatsInAttendance, chatsWaitingAttendance: chatsWaitingAttendance })


      //this.getChatIndicators(id, filterId, chatFilterId)
      //var pagination = this.setPagination(count, page, 10);
      //this.setState({ loading: false, count: count, pageStart: pagination.pageStart, pageEnd: pagination.pageEnd, chats: chatList })
      //setCount(chatList.length);

    }
    else {
      const intl = this.props.intl;
      this.setState({
        loading: false, loadingNewConversation: false, openNotification: true, notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });
      Api2Talk.kickoff(result)

    }


  }

  scrollToBottom = () => {

    //this.ref.current.scrollIntoView({ behavior: 'smooth' });
    //window.scrollTo(0, document.documentElement.scrollHeight);
    const element = document.documentElement; // ou qualquer outro elemento que você deseja rolar para
    element.scrollIntoView({ behavior: 'smooth', block: 'end' });
  };

  clearFilters() {
    this.setState((prevState) => ({
      item: {
        ...prevState.item,
        filterId: { id: 0, name: '' },
        chatFilterId: { id: 0, name: '' }
      },
      chatFilter: []
    }));
  }

  async StatusOptions() {
    //this.setState({ loading: true })
    let result = await getUserStatusList()
    if (result && result.success) {

      let statusOptions = result.data;

      this.setState({ statusOptions: statusOptions })

      //setCount(chatList.length);

    }
    else {
      const intl = this.props.intl;
      this.setState({
        openNotification: true, notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });

    }
  }
  async getEnabledUsers() {
    this.setState({ loadingAgents: true })
    var userStatusId = 6;
    let userId = this.props.userSession && this.props.userSession.user ? this.props.userSession.user.id : null
    let result = await getEnabledUsers()
    if (result && result.success) {

      PapiroConsole.log(result)
      PapiroConsole.log("result data")

      let enableUsers = result.data;

      if (userId) {

        var currentUser = enableUsers.find(item => item.userid === userId);
        userStatusId = currentUser ? currentUser.userstatusid : 6

      }

      this.setState({ loadingAgents: false, enableUsers: enableUsers ? enableUsers : [], userStatusId: userStatusId })

    }
    else {
      const intl = this.props.intl;
      this.setState({
        loadingAgents: false,
        openNotification: true, notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });

    }
  }

  async getModalOptions() {
    
    let result = await getModalOptions()
    if (result && result.success) {
      this.setState({
        messageProvidersList : result.data.messageproviderlist != null ? result.data.messageproviderlist : [],
        registrationNumberRequestList : result.data.registrationnumberrequestlist != null ? result.data.registrationnumberrequestlist  : [],
        templateMessageList : result.data.templatemessagelist != null ? result.data.templatemessagelist  : [],
        templateMessageListComplete : result.data.templatemessagelist != null ? result.data.templatemessagelist  : []
        })
    }
    else {
      const intl = this.props.intl;
      this.setState({
        openNotification: true, notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });

    }
  }

  async getChatIndicators(id, filterId, chatFilterId) {

    PapiroConsole.log("filterId")
    PapiroConsole.log("chatFilterId")
    PapiroConsole.log(filterId)
    PapiroConsole.log(chatFilterId)

    if (filterId && chatFilterId) {
      filterId = filterId.id
      chatFilterId = chatFilterId.id
    }

    this.setState({ loadingIndicators: true })

    let result = await getChatIndicators(filterId, chatFilterId)
    if (result && result.success) {
      PapiroConsole.log("result endpoint indicadores")
      PapiroConsole.log(result)

      let countNewChats = result.data.countnewchats
      let countChatsResolvedInTheFirstService = result.data.countchatsresolvedinthefirstservice
      let countChatsNotResolvedInTheFirstService = result.data.countchatsnotresolvedinthefirstservice
      let countInAttendanceChats = result.data.countinattendancechats
      let countCanceledChats = result.data.countcanceledchats
      let countFinishChats = result.data.countfinishchats

      this.setState({ loadingIndicators: false, countNewChats: countNewChats, countInAttendanceChats: countInAttendanceChats, countCanceledChats: countCanceledChats, countFinishChats: countFinishChats, countChatsResolvedInTheFirstService: countChatsResolvedInTheFirstService, countChatsNotResolvedInTheFirstService: countChatsNotResolvedInTheFirstService })

    }
    else {
      const intl = this.props.intl;
      this.setState({
        loadingIndicators: false,
        openNotification: true, notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });

    }
  }

  async getChatsWithoutChannelQueue() {
    this.setState({ loadingWithoutChannel: true })
    const result = await getChatsWithoutChannelService()

    if (result && result.success) {
      const data = result.data || {}
      const groups = data.groups || []
      const selectedWithoutChannelChannels = { ...this.state.selectedWithoutChannelChannels }

      groups.forEach(group => {
        const groupKey = group.registrationnumberrequestid || 'unidentified'
        const channels = group.channels || []
        const currentChannelStillAvailable = channels.some(channel => channel.id === selectedWithoutChannelChannels[groupKey])
        if (!currentChannelStillAvailable) {
          const preferredChannel = channels.find(channel => channel.isdefault) || channels[0]
          selectedWithoutChannelChannels[groupKey] = preferredChannel ? preferredChannel.id : ''
        }
      })

      this.setState({
        loadingWithoutChannel: false,
        withoutChannelGroups: groups,
        canAssociateWithoutChannel: Boolean(data.canassociatechannels),
        selectedWithoutChannelChannels
      })
      return
    }

    this.setState({
      loadingWithoutChannel: false,
      openNotification: true,
      notificationVariant: 'error',
      notificationMessage: this.getWithoutChannelError(result)
    })
    Api2Talk.kickoff(result)
  }

  getWithoutChannelError = result => {
    const intl = this.props.intl
    if (result && result.errors && result.errors[0]) return result.errors[0]
    if (result && result.data && result.data.errors && result.data.errors[0]) return result.data.errors[0]
    if (result && result.response && result.response.data && result.response.data.errors && result.response.data.errors[0]) return result.response.data.errors[0]
    return intl.formatMessage({ id: 'process.error' })
  }

  getGroupMessageProviderId = group => {
    const providerIds = [...new Set((group.chats || [])
      .map(chat => Number(chat.messageproviderid))
      .filter(providerId => providerId > 0))]

    return providerIds.length === 1 ? providerIds[0] : null
  }

  handleOpenChannelAssociation = async group => {
    if (!group || !group.registrationnumberrequestid) {
      this.setState({
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: this.props.intl.formatMessage({ id: 'chat.without.channel.associate.registration.invalid.number' })
      })
      return
    }

    const messageProviderId = this.getGroupMessageProviderId(group)
    if (!messageProviderId) {
      this.setState({
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: this.props.intl.formatMessage({ id: 'chat.without.channel.associate.registration.invalid.provider' })
      })
      return
    }

    this.setState({
      channelAssociationOpen: true,
      channelAssociationGroup: group,
      channelAssociationOptions: [],
      channelAssociationSelectedId: '',
      loadingChannelAssociationOptions: true
    })

    const result = await GetAllActiveAndByMessageProvider(messageProviderId)
    if (result && result.success) {
      this.setState({
        loadingChannelAssociationOptions: false,
        channelAssociationOptions: result.data || []
      })
      return
    }

    this.setState({
      loadingChannelAssociationOptions: false,
      openNotification: true,
      notificationVariant: 'error',
      notificationMessage: this.getWithoutChannelError(result)
    })
  }

  handleCloseChannelAssociation = () => {
    if (
      this.state.loadingChannelAssociationOptions
      || this.state.savingChannelAssociation
      || this.state.channelAssociationDefaultConfirmationOpen
    ) return

    this.setState({
      channelAssociationOpen: false,
      channelAssociationGroup: null,
      channelAssociationOptions: [],
      channelAssociationSelectedId: ''
    })
  }

  handleChannelAssociationSelection = event => {
    this.setState({ channelAssociationSelectedId: event.target.value })
  }

  isDefaultAssociationConfirmationRequired = result => Boolean(
    result
    && (
      (result.data && result.data.requiresconfirmation === true)
      || (result.errors && result.errors[0] === 'default.association.requires.confirmation')
    )
  )

  handleSaveChannelAssociation = async (confirmDefaultChange = false) => {
    const group = this.state.channelAssociationGroup
    const channelId = this.state.channelAssociationSelectedId

    if (!group || !group.registrationnumberrequestid || !channelId) {
      this.setState({
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: this.props.intl.formatMessage({ id: 'chat.without.channel.error.channel.required' })
      })
      return
    }

    this.setState({ savingChannelAssociation: true })
    const result = await saveChannelAssociation(
      group.registrationnumberrequestid,
      channelId,
      confirmDefaultChange
    )

    if (result && result.success) {
      await this.getChatsWithoutChannelQueue()
      this.setState({
        savingChannelAssociation: false,
        channelAssociationOpen: false,
        channelAssociationGroup: null,
        channelAssociationOptions: [],
        channelAssociationSelectedId: '',
        channelAssociationDefaultConfirmationOpen: false,
        openNotification: true,
        notificationVariant: 'success',
        notificationMessage: this.props.intl.formatMessage({ id: 'chat.without.channel.associate.registration.success' })
      })
      return
    }

    if (this.isDefaultAssociationConfirmationRequired(result)) {
      this.setState({
        savingChannelAssociation: false,
        channelAssociationDefaultConfirmationOpen: true
      })
      return
    }

    this.setState({
      savingChannelAssociation: false,
      channelAssociationDefaultConfirmationOpen: false,
      openNotification: true,
      notificationVariant: 'error',
      notificationMessage: this.getWithoutChannelError(result)
    })
  }

  handleCloseChannelAssociationDefaultConfirmation = () => {
    if (!this.state.savingChannelAssociation) {
      this.setState({ channelAssociationDefaultConfirmationOpen: false })
    }
  }

  handleConfirmChannelAssociationDefaultChange = () => {
    this.setState({ channelAssociationDefaultConfirmationOpen: false }, () => {
      this.handleSaveChannelAssociation(true)
    })
  }

  handleOpenConversationMessages = async chat => {
    if (!chat || !chat.id) return

    this.setState({
      conversationMessagesModalOpen: true,
      conversationMessagesChat: chat,
      conversationMessages: [],
      loadingConversationMessages: true,
      conversationMessagesError: ''
    })

    const result = await getChatMessages(chat.id)
    if (result && result.success) {
      this.setState({
        conversationMessages: Array.isArray(result.data) ? result.data : [],
        loadingConversationMessages: false
      })
      return
    }

    this.setState({
      loadingConversationMessages: false,
      conversationMessagesError: this.getWithoutChannelError(result)
    })
  }

  handleCloseConversationMessages = () => {
    if (this.state.loadingConversationMessages) return

    this.setState({
      conversationMessagesModalOpen: false,
      conversationMessagesChat: null,
      conversationMessages: [],
      conversationMessagesError: ''
    })
  }

  handleWithoutChannelSelection = (groupKey, channelId) => {
    this.setState(previousState => ({
      selectedWithoutChannelChannels: {
        ...previousState.selectedWithoutChannelChannels,
        [groupKey]: channelId
      }
    }))
  }

  refreshAfterWithoutChannelAssociation = async () => {
    await Promise.all([
      this.getChats(null, null, null, false),
      this.getChatsWithoutChannelQueue(),
      this.getChatIndicators()
    ])
  }

  handleAssociateWithoutChannelChat = (chatId, group) => {
    const groupKey = group.registrationnumberrequestid || 'unidentified'
    const channelId = this.state.selectedWithoutChannelChannels[groupKey]
    if (!channelId) {
      this.setState({
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: this.props.intl.formatMessage({ id: 'chat.without.channel.error.channel.required' })
      })
      return
    }

    this.setState({
      withoutChannelConfirmationOpen: true,
      withoutChannelConfirmationGroup: group,
      withoutChannelConfirmationChatId: chatId
    })
  }

  handleOpenWithoutChannelBulkConfirmation = group => {
    this.setState({
      withoutChannelConfirmationOpen: true,
      withoutChannelConfirmationGroup: group,
      withoutChannelConfirmationChatId: null
    })
  }

  handleCloseWithoutChannelConfirmation = () => {
    if (!this.state.associatingWithoutChannel) {
      this.setState({
        withoutChannelConfirmationOpen: false,
        withoutChannelConfirmationGroup: null,
        withoutChannelConfirmationChatId: null
      })
    }
  }

  handleConfirmWithoutChannelAssociation = async () => {
    const group = this.state.withoutChannelConfirmationGroup
    if (!group || !group.registrationnumberrequestid) return

    const groupKey = group.registrationnumberrequestid
    const channelId = this.state.selectedWithoutChannelChannels[groupKey]
    const chatId = this.state.withoutChannelConfirmationChatId
    const isIndividualAssociation = Boolean(chatId)
    if (!channelId) {
      this.setState({
        withoutChannelConfirmationOpen: false,
        withoutChannelConfirmationGroup: null,
        withoutChannelConfirmationChatId: null,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: this.props.intl.formatMessage({ id: 'chat.without.channel.error.channel.required' })
      })
      return
    }

    this.setState({ associatingWithoutChannel: true })
    const result = isIndividualAssociation
      ? await associateWithoutChannelChat(chatId, channelId)
      : await associateAllWithoutChannelChats(group.registrationnumberrequestid, channelId)
    if (result && result.success) {
      const updatedCount = result.data && result.data.updatedcount ? result.data.updatedcount : (group.chats || []).length
      await this.refreshAfterWithoutChannelAssociation()
      this.setState({
        associatingWithoutChannel: false,
        withoutChannelConfirmationOpen: false,
        withoutChannelConfirmationGroup: null,
        withoutChannelConfirmationChatId: null,
        openNotification: true,
        notificationVariant: 'success',
        notificationMessage: isIndividualAssociation
          ? this.props.intl.formatMessage({ id: 'chat.without.channel.success.one' })
          : this.props.intl.formatMessage(
            { id: 'chat.without.channel.success.all' },
            { count: updatedCount }
          )
      })
      return
    }

    this.setState({
      associatingWithoutChannel: false,
      withoutChannelConfirmationOpen: false,
      withoutChannelConfirmationGroup: null,
      withoutChannelConfirmationChatId: null,
      openNotification: true,
      notificationVariant: 'error',
      notificationMessage: this.getWithoutChannelError(result)
    })
  }

  async getTeamMismatchQueue() {
    this.setState({ loadingTeamMismatch: true })
    const result = await getTeamMismatchChats()

    if (result && result.success) {
      const data = result.data || {}
      this.setState({
        loadingTeamMismatch: false,
        teamMismatchGroups: data.groups || [],
        canRepairTeamMismatch: Boolean(data.canrepairteams)
      })
      return
    }

    this.setState({
      loadingTeamMismatch: false,
      openNotification: true,
      notificationVariant: 'error',
      notificationMessage: this.getWithoutChannelError(result)
    })
    Api2Talk.kickoff(result)
  }

  refreshAfterTeamMismatchRepair = async () => {
    await Promise.all([
      this.getChats(null, null, null, false),
      this.getTeamMismatchQueue(),
      this.getChatIndicators()
    ])
  }

  handleOpenTeamMismatchConfirmation = (group, chatId = null) => {
    this.setState({
      teamMismatchConfirmationOpen: true,
      teamMismatchConfirmationGroup: group,
      teamMismatchConfirmationChatId: chatId
    })
  }

  handleCloseTeamMismatchConfirmation = () => {
    if (!this.state.repairingTeamMismatch) {
      this.setState({
        teamMismatchConfirmationOpen: false,
        teamMismatchConfirmationGroup: null,
        teamMismatchConfirmationChatId: null
      })
    }
  }

  handleConfirmTeamMismatchRepair = async () => {
    const group = this.state.teamMismatchConfirmationGroup
    if (!group) return

    const chatId = this.state.teamMismatchConfirmationChatId
    const isIndividualRepair = Boolean(chatId)
    if (!isIndividualRepair && !group.registrationnumberrequestid) return

    this.setState({ repairingTeamMismatch: true })
    const result = isIndividualRepair
      ? await repairTeamMismatchChat(chatId)
      : await repairAllTeamMismatchChats(group.registrationnumberrequestid)

    if (result && result.success) {
      const updatedCount = result.data && result.data.updatedcount
        ? result.data.updatedcount
        : (group.chats || []).length
      await this.refreshAfterTeamMismatchRepair()
      this.setState({
        repairingTeamMismatch: false,
        teamMismatchConfirmationOpen: false,
        teamMismatchConfirmationGroup: null,
        teamMismatchConfirmationChatId: null,
        openNotification: true,
        notificationVariant: 'success',
        notificationMessage: isIndividualRepair
          ? this.props.intl.formatMessage({ id: 'chat.team.mismatch.success.one' })
          : this.props.intl.formatMessage(
            { id: 'chat.team.mismatch.success.all' },
            { count: updatedCount }
          )
      })
      return
    }

    this.setState({
      repairingTeamMismatch: false,
      teamMismatchConfirmationOpen: false,
      teamMismatchConfirmationGroup: null,
      teamMismatchConfirmationChatId: null,
      openNotification: true,
      notificationVariant: 'error',
      notificationMessage: this.getWithoutChannelError(result)
    })
  }





  async getEnabledUserById(id) {
    this.setState({ loading: true })
    PapiroConsole.log("id aqui ")
    PapiroConsole.log(id)
    let result = await getEnabledUserById(id)
    if (result && result.success) {



      //caso ele não esteja ativo ou esteja ativo e não tenha status, tomar como offline o status do agente
      this.setState({ loading: false, userStatusId: result.data && result.data.userstatusid ? result.data.userstatusid : 6 })



      //setCount(chatList.length);

    }
    else {
      const intl = this.props.intl;
      this.setState({
        loading: false, openNotification: true, notificationVariant: 'error',
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });

    }
  }

  async redirectChat(e, id) {

    const { props } = this.props;

    if (props && props.match) {
      const { lang } = props.match.params

      if (id != null) {
        PapiroConsole.log("entrei no observar")
        props.history.push(`/${lang}/omnichannel-observe/${id}`);

      }

    }

    else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: 'Ocorreu um erro ao redirecionar para a conversa.'
      });


    }
  }

  async updateChat(e, id, observe = false, forceGroup = false) {
    e.preventDefault()
    e.stopPropagation();

    // TEMP (debug admin id=1): flag lida no seam (components/chat/index.js) pra forcar a visao de grupo
    // sobre a conversa real. forceGroup=false (todos os "Entrar"/"Responder" normais) LIMPA a flag -> 1:1.
    try {
      if (forceGroup) window.sessionStorage.setItem('mexx_debug_force_group', String(id));
      else window.sessionStorage.removeItem('mexx_debug_force_group');
    } catch (err) { /* sessionStorage indisponivel: ignora */ }

    this.setState({ loading: true })
    const { props } = this.props;

    PapiroConsole.log("entrei aqui updateChat ")

    let sentData = {
      chatId: id,
      connectionid: this.state.userSession.connectionid
    }

    Api2Talk.put(`/chat/assigneduser`, sentData)
      .then(result => {

        if (result.data.success) {

          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: 'Atendimento iniciado com sucesso'
          });

          if (props && props.match) {
            const { lang } = props.match.params

            if (observe == false) {
              PapiroConsole.log("primeiro redirecionamento")

              //props.history.push(`/${lang}/omnichannel`);
              props.history.push({
                pathname: `/${lang}/omnichannel`,
                state: {
                  chatId: id
                }
              })
            }
            else {
              if (id != null) {
                PapiroConsole.log("entrei no observar")
                props.history.push(`/${lang}/omnichannel-observe/${id}`);

              }
              else {
                this.setState({
                  loading: false,
                  openNotification: true,
                  notificationVariant: 'error',
                  notificationMessage: 'Ocorreu um erro ao redirecionar para a conversa.'
                });

              }


            }

          }


        }
        else {
          const intl = this.props.intl;
          let notificatonMessage = "";
          let refreshDash = false;

          if (result.data && result.data.errors && result.data.errors[0]) {
            notificatonMessage = result.data && result.data.errors && result.data.errors[0] ? result.data.errors[0] : intl.formatMessage({ id: "process.error" });
          } else {
            if (result.data?.message) {
              notificatonMessage = result.data?.message;
              refreshDash = true;
            }
          }

          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: notificatonMessage
          });

          if (refreshDash) {
            this.componentDidMount(refreshDash);
          }

        }
      })
      .catch(err => {
        PapiroConsole.log(err)
        PapiroConsole.log("err aqui encontrado")
        if (err.response && err.response.data && err.response.data.errors) {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
        }
        else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: err && err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })

          });
        }
      });


  }

  async changeStatus(id) {

    this.setState({ loading: true })
    const { props } = this.props;

    Api2Talk.put(`/enableusers/changestatus/${id}`)
      .then(result => {

        PapiroConsole.log("resultado enable users")
        PapiroConsole.log(result)
        if (result.data.success) {

          let agentList = this.state.enableUsers;

          if (result.data.data && result.data.data.length > 0) {
            agentList = result.data.data;
          }

          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: 'Status Alterado com sucesso',
            userStatusId: id,
            enableUsers: agentList
          });


        }
        else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: result.data && result.data.errors && result.data.errors[0] ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });

        }
      })
      .catch(err => {
        if (err.response && err.response.data && err.response.data.errors) {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
        }
        else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: err && err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })

          });
        }
      });


  }

  async changeValues(stateName, value, text = "") {

    if (stateName == "status") {
      await this.changeStatus(value)
      return
    }

    if (stateName == "filterId") {
      let chatFilter = []

      if (value.id == 1) {
        chatFilter = [
          { id: 1, name: 'Todas' },
          { id: 2, name: 'Minhas conversas' },
          { id: 3, name: 'Conversas de outros agentes' },
        ]
      }
      this.setState((prevState) => ({
        item: {
          ...prevState.item,
          [stateName]: value,
          chatFilterId: { id: 0, name: '' }
        },
        chatFilter: chatFilter
      }));

    }
    else {
      this.setState((prevState) => ({
        item: {
          ...prevState.item,
          [stateName]: value,
        }
      }));
    }



  }

  changeIndex(index) {
    PapiroConsole.log(index);
    PapiroConsole.log("index");
    this.setState({ tabSelected: index },
      () => {
        // Esta função será chamada após o estado ter sido atualizado
        this.scrollToBottom();
      }
    )


  }




  async componentDidMount(refreshdashboard = false) {

    PapiroConsole.log("this.props aqui")
    PapiroConsole.log(this.props)

    await this.getChats(null, null, null, refreshdashboard);
    if (hasAdministrationQueueAccess(this.props.userSession)) {
      await this.getChatsWithoutChannelQueue();
      await this.getTeamMismatchQueue();
    }
    this.getChatIndicators()
    this.getEnabledUsers()
    await this.StatusOptions()
     this.getModalOptions();
    //await this.getEnabledUserById(this.props.userSession && this.props.userSession.user ? this.props.userSession.user.id : null)


  }

  handleOpenModal = () => {
    this.setState({ modalOpen: true });
  };

  handleCloseModal = () => {
    this.setState({ modalOpen: false });
  };

  setLoading = value => this.setState({ loading: value })
  
  
  setTemplateMessageList = list => this.setState({ templateMessageList: list })
  setTemplateMessageListComplete = list => this.setState({ templateMessageList: [...this.state.templateMessageListComplete] })

  setMessage = (open, variant, message) => this.setState({ openNotification: open, notificationVariant: variant, notificationMessage: message })

 




  render() {
    PapiroConsole.log(this.state)
    PapiroConsole.log("this.state")
    PapiroConsole.log(this.props)
    PapiroConsole.log("this.props primeira página ")
    PapiroConsole.log("this.props primeira página ")

    const { classes } = this.props;


    const intl = this.props.intl;
    const canViewAdministrationQueues = hasAdministrationQueueAccess(this.props.userSession)

    // Determina quais chats mostrar (filtrados ou originais)
    const chatsWaitingToDisplay = (this.state.isFilterActive
      ? this.state.filteredChatsWaitingAttendance
      : this.state.chatsWaitingAttendance) || [];

    const myChatsToDisplay = (this.state.isFilterActive
      ? this.state.filteredMyChatsInAttendance
      : this.state.myChatsInAttendance) || [];

    const otherChatsToDisplay = (this.state.isFilterActive
      ? this.state.filteredOtherChatsInAttendance
      : this.state.otherChatsInAttendance) || [];

    const withoutChannelGroupsToDisplay = filterWithoutChannelGroups(
      this.state.withoutChannelGroups,
      this.state.conversationSearchTerm
    )
    const withoutChannelChatsCount = withoutChannelGroupsToDisplay.reduce(
      (total, group) => total + (group.chats || []).length,
      0
    )
    const teamMismatchGroupsToDisplay = filterTeamMismatchGroups(
      this.state.teamMismatchGroups,
      this.state.conversationSearchTerm
    )
    const teamMismatchChatsCount = teamMismatchGroupsToDisplay.reduce(
      (total, group) => total + (group.chats || []).length,
      0
    )
    const hasConversationSearch = Boolean(this.state.conversationSearchTerm.trim())
    const hasActiveConversationFilter = this.state.isFilterActive || hasConversationSearch

    return (
      <Grid container style={{ paddingRight: '20px', paddingLeft: '20px' }} >
        {/* Topbar: "Nova conversa" (esquerda) + combo de status do agente (direita).
            Movido pro TOPO da página neste refactor — antes ficava abaixo do bloco Conversas/Filtros.
            Spacers xs={3} vazios entre os dois mantêm o alinhamento "esquerda × direita" (4×3=12). */}
        <Grid container spacing={3}  >
          <Grid item xs={3}  >
            <Button
              variant="contained"
              color="secondary"
              size="large"
              className={classes.button}
              startIcon={<AddIcon />}
              onClick={this.handleOpenModal}

            >
              Nova conversa
            </Button>
          </Grid>


          <Grid item xs={3} />
          <Grid item xs={3} />
          <Grid item xs={3} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'right' }} >
            <SimpleSelectWithRoundedColor
                options={this.state.statusOptions}
                stateName="status"
                changeSelect={this.changeValues}
                selected={this.state.userStatusId}

            />
          </Grid>
        </Grid>


        {/* Acordeon "Pesquisa / Indicadores" — fechado por default p/ dar primeira impressão limpa.
            Antes era chamado "Mensageria" (i18n key menu.2talk) e continha SÓ os indicadores+agentes.
            Agora contém em ordem:
              1) Filtros — anteriormente Card "Conversas" FORA do acordeon (linhas 830-899 originais).
                 Título interno mudou de "Chats" → "Filtros" (nova chave i18n).
              2) ChatIndicators + AgentList — mantidos exatamente como já estavam aqui dentro.
              3) TagSearchFilter — anteriormente em Grid container separado FORA do acordeon.
            Todos os handlers (callingFilters, clearFilters, changeValues, handleFilteredChatsChange)
            e props seguem 100% idênticos — só o lugar do JSX mudou. */}
        <Accordion style={{ width: "100%", marginTop: '15px' }} defaultExpanded={false}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className={classes.heading}>{intl.formatMessage({ id: "chat.attendance.list.section.title" })}</Typography>
          </AccordionSummary>
          <AccordionDetails>

            <Grid container spacing={2} style={{ marginTop: '10px' }}>

              {/* Item 1: Filtros — mesma estrutura do antigo Card "Conversas", agora num StyledPaper
                  pra acompanhar o padrão visual dos outros 2 itens do acordeon. */}
              <Grid item xs={12}>
                <StyledPaper elevation={3} style={{ padding: 20 }}>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item xs={12} sm={12} lg={4}>
                      <Typography component={'span'} variant="h6" color="textSecondary">
                        {intl.formatMessage({ id: "chat.attendance.list.filters.title" })}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={8}>
                      <Grid container spacing={1} direction="row" alignItems="center">
                        <Grid item xs={12} sm={12} md={12} lg={4} >
                          <SimpleAutoComplete
                            label="Filtro"
                            stateName="filterId"
                            options={this.state.filterOptions}
                            changeSelect={this.changeValues}
                            selected={this.state.item.filterId}
                          /*
                          stateName="techinicalTeam"
                          changeSelect={changeValues}
                          selected={techinicalTeam}*/
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={4} >
                          <SimpleAutoComplete
                            label="Complemento"
                            stateName="chatFilterId"
                            options={this.state.chatFilter}
                            changeSelect={this.changeValues}
                            selected={this.state.item.chatFilterId}
                          /*
                          stateName="techinicalTeam"
                          changeSelect={changeValues}
                          selected={techinicalTeam}*/
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} lg={2} style={{ display: 'flex', justifyContent: 'center' }}>
                          <Button
                            fullWidth
                            variant='contained'
                            color='primary'
                            size="large"
                            onClick={() => this.callingFilters(null, this.state.item.filterId, this.state.item.chatFilterId)}
                          >
                            {intl.formatMessage({ id: "apply" })}
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={2}>
                          <Button
                            fullWidth
                            variant='contained'
                            color='secondary'
                            size="large"
                            onClick={() => this.clearFilters()}
                          >
                            {intl.formatMessage({ id: "clear" })}

                          </Button>
                        </Grid>


                      </Grid>
                    </Grid>
                  </Grid>
                </StyledPaper>
              </Grid>

              {/* Item 2: Indicadores + Agentes — bloco preservado idêntico ao original que já vivia aqui. */}
              <Grid item xs={12} md={6}>
                <StyledPaper elevation={3} style={{ padding: 20, overflow: 'auto', height: '370px' }} >

                  {/* Adicione aqui os indicadores de chat */}
                  <ChatIndicators loadingIndicators={this.state.loadingIndicators} countNewChats={this.state.countNewChats} countInAttendanceChats={this.state.countInAttendanceChats} countCanceledChats={this.state.countCanceledChats} countFinishChats={this.state.countFinishChats} countChatsNotResolvedInTheFirstService={this.state.countChatsNotResolvedInTheFirstService} countChatsResolvedInTheFirstService={this.state.countChatsResolvedInTheFirstService} />
                </StyledPaper>
              </Grid>
              <Grid item xs={12} md={6}>
                <StyledPaper elevation={3} style={{ padding: 20, overflow: 'auto', height: '370px' }}>

                  <AgentList loadingAgents={this.state.loadingAgents} statusOptions={this.state.statusOptions} userStatusId={this.state.userStatusId} enableUsers={this.state.enableUsers} changeStatus={this.changeStatus} />
                </StyledPaper>
              </Grid>

              {/* Item 3: Busca por tags — wrap em StyledPaper pra acompanhar a "voz visual" dos outros itens. */}
              <Grid item xs={12}>
                <StyledPaper elevation={3} style={{ padding: 20 }}>
                  <TagSearchFilter
                    chats={this.state.chats}
                    onFilteredChatsChange={this.handleFilteredChatsChange}
                    onSearchTermChange={this.handleConversationSearchTermChange}
                    placeholder={intl.formatMessage({ id: 'chat.search.tags.or.customer' })}
                    showTagSuggestions={true}
                  />
                </StyledPaper>
              </Grid>

            </Grid>


          </AccordionDetails>
        </Accordion>

        <Grid container spacing={0} style={{ marginTop: '30px' }}>



          <Box display="flex" alignItems="center" flexDirection="row" style={{ marginBottom: '10px' }}>
            <Typography variant="h5" color="primary" >
              Conversas aguardando atendimento
               {this.state.isFilterActive && ` (${chatsWaitingToDisplay.length})`}
            </Typography>
            {this.state.loadingNewConversation &&

              <CircularProgress size={24} style={{ marginLeft: 13 }} />
            }


          </Box>
{/*
          {this.state.chatsWaitingAttendance.length > 0 ? (
            // Se há elementos no array, renderiza os elementos


            <>


              {this.state.chatsWaitingAttendance.map((item) => {
                return <ItemCard
                  chats={item}
                  name="chatsWaitingAttendance"
                  updateChat={this.updateChat}
                  currentUserId={this.state.userId}
                  redirectChat={this.redirectChat}
                />
              })}
            </>
          ) : (
            <Grid item xs={12}>
              <Typography variant="body1" style={{ color: '#7f8c8d', marginBottom: '10px' }} >
                Não há conversas aguardando atendimento
              </Typography>
            </Grid>

          )}

*/}

        {chatsWaitingToDisplay && chatsWaitingToDisplay.length > 0 ? (
          <>
            {chatsWaitingToDisplay.map((item) => {
              return <ItemCard
                key={item.id} // Adicione key para melhor performance
                chats={item}
                name="chatsWaitingAttendance"
                updateChat={this.updateChat}
                currentUserId={this.state.userId}
                redirectChat={this.redirectChat}
              />
            })}
          </>
        ) : (
          <Grid item xs={12}>
            <Typography variant="body1" style={{ color: '#7f8c8d', marginBottom: '10px' }} >
              {this.state.isFilterActive 
                ? intl.formatMessage({ id: 'chat.search.empty' })
                : 'Não há conversas aguardando atendimento'
              }
            </Typography>
          </Grid>
        )}

        </Grid>




          {/* SEÇÃO: Conversas em andamento */}
          <Grid container spacing={0} style={{ marginTop: '30px' }}>
            <Box>
              <Typography variant="h5" color="primary" style={{ marginBottom: '10px' }}>
                Conversas em andamento
                {hasActiveConversationFilter && ` (${myChatsToDisplay.length + otherChatsToDisplay.length + (canViewAdministrationQueues ? withoutChannelChatsCount + teamMismatchChatsCount : 0)})`}
              </Typography>
            </Box>
            
            <Grid item xs={12} style={{ marginTop: '10px', marginBottom:'10px' }} >
              <Tabs selectedIndex={this.state.tabSelected} onSelect={index => this.changeIndex(index)}>
                <Grid item xs={12}>
                  <TabList style={{ borderColor: '#BB8FCE' }}>
                    <Tab style={{ fontSize: "14px" }}>
                      <SpeakerNotesIcon /> Minhas conversas
                      <Badge sx={{
                        "& .MuiBadge-badge": { color: "white", backgroundColor: "#f47920" },
                        marginLeft: '10px', marginRight: '5px', marginBottom: '8px'
                      }} badgeContent={myChatsToDisplay.length} ></Badge>
                    </Tab>

                    <Tab style={{ fontSize: "14px" }}>
                      <ThreePIcon /> Outras conversas
                      <Badge sx={{
                        "& .MuiBadge-badge": { color: "white", backgroundColor: "#f47920" },
                        marginLeft: '10px', marginRight: '5px', marginBottom: '8px'
                      }} badgeContent={otherChatsToDisplay.length} ></Badge>
                    </Tab>

                    {canViewAdministrationQueues && (
                      <Tab style={{ fontSize: "14px" }}>
                        <LinkOffIcon /> {intl.formatMessage({ id: 'chat.without.channel.section.title' })}
                        {shouldShowAdministrationQueueBadge(withoutChannelChatsCount) && (
                          <Badge sx={{
                            "& .MuiBadge-badge": { color: "white", backgroundColor: "#f47920" },
                            marginLeft: '10px', marginRight: '5px', marginBottom: '8px'
                          }} badgeContent={withoutChannelChatsCount}></Badge>
                        )}
                      </Tab>
                    )}

                    {canViewAdministrationQueues && (
                      <Tab style={{ fontSize: "14px" }}>
                        <SyncAltIcon /> {intl.formatMessage({ id: 'chat.team.mismatch.section.title' })}
                        {shouldShowAdministrationQueueBadge(teamMismatchChatsCount) && (
                          <Badge sx={{
                            "& .MuiBadge-badge": { color: "white", backgroundColor: "#f47920" },
                            marginLeft: '10px', marginRight: '5px', marginBottom: '8px'
                          }} badgeContent={teamMismatchChatsCount}></Badge>
                        )}
                      </Tab>
                    )}
                  </TabList>
                </Grid>

                <TabPanel>
                  {myChatsToDisplay.length > 0 ? myChatsToDisplay.map(item => (
                    <ItemCard
                      key={item.id}
                      chats={item}
                      name="myChatsInAttendance"
                      updateChat={this.updateChat}
                      currentUserId={this.state.userId}
                    />
                  )) : (
                    <Typography variant="body1" style={{ color: '#7f8c8d', marginBottom: '10px' }}>
                      {hasActiveConversationFilter
                        ? intl.formatMessage({ id: 'chat.search.empty' })
                        : 'Não há conversas a serem exibidas'}
                    </Typography>
                  )}
                </TabPanel>

                <TabPanel>
                  {otherChatsToDisplay.length > 0 ? otherChatsToDisplay.map(item => (
                    <ItemCard
                      key={item.id}
                      chats={item}
                      name="otherChatsInAttendance"
                      redirectChat={this.redirectChat}
                      currentUserId={this.state.userId}
                    />
                  )) : (
                    <Typography variant="body1" style={{ color: '#7f8c8d', marginBottom: '10px' }}>
                      {hasActiveConversationFilter
                        ? intl.formatMessage({ id: 'chat.search.empty' })
                        : 'Não há conversas a serem exibidas'}
                    </Typography>
                  )}
                </TabPanel>

                {canViewAdministrationQueues && (
                  <TabPanel>
                    <WithoutChannelConversations
                      embedded
                      groups={withoutChannelGroupsToDisplay}
                      canAssociateChannels={this.state.canAssociateWithoutChannel}
                      selectedChannels={this.state.selectedWithoutChannelChannels}
                      loading={this.state.loadingWithoutChannel}
                      associating={this.state.associatingWithoutChannel}
                      intl={intl}
                      emptyMessage={hasConversationSearch ? intl.formatMessage({ id: 'chat.search.empty' }) : null}
                      onChannelChange={this.handleWithoutChannelSelection}
                      onAssociateChat={this.handleAssociateWithoutChannelChat}
                      onAssociateAll={this.handleOpenWithoutChannelBulkConfirmation}
                      onOpenChannelAssociation={this.handleOpenChannelAssociation}
                      onViewMessages={this.handleOpenConversationMessages}
                    />
                  </TabPanel>
                )}

                {canViewAdministrationQueues && (
                  <TabPanel>
                    <TeamMismatchConversations
                      embedded
                      groups={teamMismatchGroupsToDisplay}
                      canRepairTeams={this.state.canRepairTeamMismatch}
                      loading={this.state.loadingTeamMismatch}
                      repairing={this.state.repairingTeamMismatch}
                      intl={intl}
                      emptyMessage={hasConversationSearch ? intl.formatMessage({ id: 'chat.search.empty' }) : null}
                      onRepairChat={(chatId, group) => this.handleOpenTeamMismatchConfirmation(group, chatId)}
                      onRepairAll={group => this.handleOpenTeamMismatchConfirmation(group)}
                      onViewMessages={this.handleOpenConversationMessages}
                    />
                  </TabPanel>
                )}
              </Tabs>
            </Grid>
          </Grid>

        <ConversationMessagesModal
          open={this.state.conversationMessagesModalOpen}
          chat={this.state.conversationMessagesChat}
          messages={this.state.conversationMessages}
          loading={this.state.loadingConversationMessages}
          error={this.state.conversationMessagesError}
          intl={intl}
          onClose={this.handleCloseConversationMessages}
        />

        <Dialog
          open={this.state.channelAssociationOpen}
          onClose={this.handleCloseChannelAssociation}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            {intl.formatMessage({ id: 'chat.without.channel.associate.registration.title' })}
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ marginBottom: '18px' }}>
              {intl.formatMessage(
                { id: 'chat.without.channel.associate.registration.description' },
                {
                  number: this.state.channelAssociationGroup
                    ? this.state.channelAssociationGroup.registrationnumberrequestphonenumber
                      || intl.formatMessage({ id: 'chat.without.channel.unknown.registration' })
                    : '-'
                }
              )}
            </DialogContentText>

            {this.state.loadingChannelAssociationOptions ? (
              <Box display="flex" justifyContent="center" sx={{ padding: '24px 0' }}>
                <CircularProgress size={28} />
              </Box>
            ) : this.state.channelAssociationOptions.length > 0 ? (
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel>{intl.formatMessage({ id: 'chat.without.channel.channels' })}</InputLabel>
                <Select
                  value={this.state.channelAssociationSelectedId}
                  onChange={this.handleChannelAssociationSelection}
                  label={intl.formatMessage({ id: 'chat.without.channel.channels' })}
                  disabled={this.state.savingChannelAssociation}
                >
                  {this.state.channelAssociationOptions.map(channel => (
                    <MenuItem key={channel.id} value={channel.id}>{channel.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <Typography color="error" variant="body2">
                {intl.formatMessage({ id: 'chat.without.channel.associate.registration.no.channels' })}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleCloseChannelAssociation}
              disabled={this.state.loadingChannelAssociationOptions || this.state.savingChannelAssociation}
            >
              {intl.formatMessage({ id: 'chat.without.channel.cancel' })}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => this.handleSaveChannelAssociation(false)}
              disabled={
                this.state.loadingChannelAssociationOptions
                || this.state.savingChannelAssociation
                || !this.state.channelAssociationSelectedId
              }
            >
              {this.state.savingChannelAssociation && (
                <CircularProgress size={18} color="inherit" sx={{ marginRight: '8px' }} />
              )}
              {intl.formatMessage({ id: 'chat.without.channel.associate.registration.confirm' })}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.channelAssociationDefaultConfirmationOpen}
          onClose={this.handleCloseChannelAssociationDefaultConfirmation}
        >
          <DialogTitle>
            {intl.formatMessage({ id: 'chat.without.channel.associate.registration.default.confirm.title' })}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {intl.formatMessage({ id: 'default.channel.association.confirmation.info' })}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleCloseChannelAssociationDefaultConfirmation}
              disabled={this.state.savingChannelAssociation}
            >
              {intl.formatMessage({ id: 'chat.without.channel.cancel' })}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={this.handleConfirmChannelAssociationDefaultChange}
              disabled={this.state.savingChannelAssociation}
            >
              {this.state.savingChannelAssociation && (
                <CircularProgress size={18} color="inherit" sx={{ marginRight: '8px' }} />
              )}
              {intl.formatMessage({ id: 'chat.without.channel.confirm' })}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.withoutChannelConfirmationOpen}
          onClose={this.handleCloseWithoutChannelConfirmation}
        >
          <DialogTitle>
            {intl.formatMessage({
              id: this.state.withoutChannelConfirmationChatId
                ? 'chat.without.channel.confirm.one.title'
                : 'chat.without.channel.confirm.title'
            })}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {(() => {
                const group = this.state.withoutChannelConfirmationGroup
                if (!group) return ''
                const groupKey = group.registrationnumberrequestid
                const selectedChannelId = this.state.selectedWithoutChannelChannels[groupKey]
                const selectedChannel = (group.channels || []).find(channel => channel.id === selectedChannelId)
                const chatId = this.state.withoutChannelConfirmationChatId
                const channelName = selectedChannel ? selectedChannel.name : '-'
                return (
                  <FormattedMessage
                    id={chatId
                      ? 'chat.without.channel.confirm.one.message'
                      : 'chat.without.channel.confirm.message'}
                    values={{
                      number: group.registrationnumberrequestphonenumber || intl.formatMessage({ id: 'chat.without.channel.unknown.registration' }),
                      channel: <strong>{`"${channelName}"`}</strong>,
                      count: (group.chats || []).length,
                      chatid: chatId
                    }}
                  />
                )
              })()}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseWithoutChannelConfirmation} disabled={this.state.associatingWithoutChannel}>
              {intl.formatMessage({ id: 'chat.without.channel.cancel' })}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={this.handleConfirmWithoutChannelAssociation}
              disabled={this.state.associatingWithoutChannel}
            >
              {this.state.associatingWithoutChannel
                ? <CircularProgress size={20} />
                : intl.formatMessage({ id: 'chat.without.channel.confirm' })}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.teamMismatchConfirmationOpen}
          onClose={this.handleCloseTeamMismatchConfirmation}
        >
          <DialogTitle>
            {intl.formatMessage({
              id: this.state.teamMismatchConfirmationChatId
                ? 'chat.team.mismatch.confirm.one.title'
                : 'chat.team.mismatch.confirm.title'
            })}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {(() => {
                const group = this.state.teamMismatchConfirmationGroup
                if (!group) return ''
                const chatId = this.state.teamMismatchConfirmationChatId
                const chatsToRepair = chatId
                  ? (group.chats || []).filter(chat => chat.id === chatId)
                  : (group.chats || [])
                const targetTeamNames = [...new Set(chatsToRepair.map(chat => (
                  chat.targettechinicalteamname
                  || (chat.targettechinicalteamid ? `#${chat.targettechinicalteamid}` : '-')
                )))]
                const targetTeams = targetTeamNames.map(name => `"${name}"`).join(', ')
                return (
                  <FormattedMessage
                    id={chatId
                      ? 'chat.team.mismatch.confirm.one.message'
                      : 'chat.team.mismatch.confirm.message'}
                    values={{
                    number: group.registrationnumberrequestphonenumber || intl.formatMessage({ id: 'chat.without.channel.unknown.registration' }),
                    team: <strong>{targetTeams}</strong>,
                    count: (group.chats || []).length,
                    chatid: chatId
                    }}
                  />
                )
              })()}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseTeamMismatchConfirmation} disabled={this.state.repairingTeamMismatch}>
              {intl.formatMessage({ id: 'chat.without.channel.cancel' })}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={this.handleConfirmTeamMismatchRepair}
              disabled={this.state.repairingTeamMismatch}
            >
              {this.state.repairingTeamMismatch
                ? <CircularProgress size={20} />
                : intl.formatMessage({ id: 'chat.without.channel.confirm' })}
            </Button>
          </DialogActions>
        </Dialog>

        <CustomModal
          open={this.state.modalOpen}
          onClose={this.handleCloseModal}
          messageProvidersList={this.state.messageProvidersList}
          registrationNumberRequestList={this.state.registrationNumberRequestList}
          templateMessageList = {this.state.templateMessageList}
          onSubmit={this.handleSubmitModal}
          intl={this.props.intl}
          setLoading={this.setLoading}
          setTemplateMessageList={this.setTemplateMessageList}
          setTemplateMessageListComplete = {this.setTemplateMessageListComplete}
          setMessage={this.setMessage} 
          match = {this.props.props.match}
          history ={this.props.props.history}
        />
        {
          this.state.loading && (
            <Overlay>
              <CircularProgress color='secondary' />
            </Overlay>
          )
        }
        <CustomizedSnackbars
          variant={this.state.notificationVariant}
          message={this.state.notificationMessage}
          isOpen={this.state.openNotification}
          toClose={this.closeNotification} />

      </Grid >
    )
  }
}

ToTalkChatAttendance.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  chats: state.chats,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ToTalkChatAttendance)));
ToTalkChatAttendance.contextType = AbilityContext;
